import React from "react";
import { TripItemType } from "src/utils/ApiSchema";

interface Props {
  icon: string;
  className?: string;
  type: TripItemType;
  onClick?: () => void;
}

function IconButton(props: Props) {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        props?.onClick?.();
      }}
      className={`px-[5px]`}
    >
      <img
        src={props.icon}
        draggable={false}
        className={
          props.className ??
          `${props.type === TripItemType.Background ? "invert dark:invert-0" : "invert-0 dark:invert"}`
        }
      />
    </button>
  );
}

export default IconButton;
